<script>
  export let title: string;
  export let desc: string = "";
  export let buttonText: string;

  let isBlockDisplayed: boolean = false;
  const showBlock = () => (isBlockDisplayed = true);
  // const hideBlock = () => (isBlockDisplayed = false);
</script>

<div class="aside-block">
  {#if title}
    <div class="aside-block__title">{title}</div>
  {/if}

  {#if desc}
    <div class="aside-block__desc">{desc}</div>
  {/if}

  {#if isBlockDisplayed}
    <div class="aside-block__body">
      <slot />
    </div>
    <!-- <button class="btn" on:click={hideBlock}>Close</button> -->
  {:else}
    <button class="btn" on:click={showBlock}>{buttonText}</button>
  {/if}
</div>

<style lang="scss">
  .aside-block {
    background-color: #ebebeb;
    padding: 30px 30px 40px;
    margin-bottom: 40px;

    &__title {
      @include h2;
      margin-bottom: 18px;
    }

    &__desc {
      @include small;
      margin-bottom: 18px;
    }

    &__body {
      margin-bottom: 10px;
    }
  }
</style>
